const initialState = {
  events: [],
  media: [],
  filterYearEvents: null,
  filterYearMedia: null,
};

const GET_MEDIA = 'GET_MEDIA';
const GET_EVENTS = 'GET_EVENTS';

export const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MEDIA:
      return { ...state, media: action.payload };
    case GET_EVENTS:
      return { ...state, events: action.payload };
    case 'SET_YEAR_FILTER_EVENTS':
      return { ...state, filterYearEvents: action.payload };
    case 'SET_YEAR_FILTER_MEDIA':
      return { ...state, filterYearMedia: action.payload };
    default:
      return state;
  }
};

export const getMediaAction = (payload) => ({ type: GET_MEDIA, payload });
export const getEventsAction = (payload) => ({ type: GET_EVENTS, payload });
export const setYearFilterEvents = (year) => ({
  type: 'SET_YEAR_FILTER_EVENTS',
  payload: year,
});

export const setYearFilterMedia = (year) => ({
  type: 'SET_YEAR_FILTER_MEDIA',
  payload: year,
});
